import React from "react";
import { Helmet } from "react-helmet";
import { Pages } from "../utils/constants";
import Hero from "../components/Home/Hero";
import Partners from "../components/Home/Partners";
import CheckIn from "../components/Home/CheckIn";
import Integrate from "../components/Home/Integrate";
import Trusted from "../components/Home/Trusted";
import CTA from "../components/Layout/CTA";
import Platform from "../components/Home/Platform";
import WithQuadrant from "../components/Home/WithQuadrant";
import ResponsibleAI from "../components/Home/ResponsibleAI";

const Home = () => {
  return (
    <div>
      <Helmet>
        <link rel="canonical" href={`https://quadrant.health${Pages.HOME}`} />
      </Helmet>

      <Hero />
      <Partners />
      <CheckIn />
      <Platform />
      <Integrate />
      <WithQuadrant />
      <Trusted />
      <ResponsibleAI />
      <CTA />
    </div>
  );
};

export default Home;
